export const facialRecognition = {
  'After finishing it, return to this page':
    'Após o término, volte para esta página',
  'Click the link below to perform the facial authentication procedure':
    'Clique no link abaixo para realizar o procedimento de reconhecimento facial.',
  'Facial recognition': 'Reconhecimento facial',
  'Make sure your face is the only one appearing in the photo':
    'Garanta que seu rosto é o único a aparecer na foto',
  'Move to a well-lit place': 'Fique em um local iluminado',
  'Please, choose how you want to identify yourself':
    'Por favor, escolha como deseja se identificar',
  'Perform authentication': 'Realizar autenticação',
  'Remove glasses or hats': 'Remova óculos ou chapéus',
  'The background should be neutral For instance, stay in from of a bright wall':
    'O fundo deve ser neutro. Por exemplo, fique diante de uma parede clara',
  'The process is fast and you only need to pass through it once for this process':
    'O processo é bem rápido e você só precisa passar por ele uma vez para este processo',
  'The selfie should be taken by the service taker customer (or by its legal guardian, in case of a minor)':
    'A selfie deve ser tirada pelo cliente tomador do serviço (ou pelo seu responsável legal, caso seja menor de idade)',
  'Try again': 'Tentar novamente',
  'Try with a recent document': 'Tente com um documento recente',
  'Try with selfie': 'Tente com selfie',
  'Try with document': 'Tente com documento',
  'Wait while we prepare the process':
    'Aguarde enquanto preparamos o processo...',
  'Wait while we verify your identity':
    'Aguarde enquanto verificamos a sua identidade',
  'We could not recognize you': 'Não conseguimos te reconhecer',
  'We could not validate your face Follow these instructions and try again':
    'Não foi possível validar o seu rosto. Siga estas instruções e tente novamente',
  'We need to verify your identity!': 'Precisamos verificar sua identidade!',
};
